import { render, staticRenderFns } from "./TSZ_Recordar_Contraseña.vue?vue&type=template&id=036666b3&scoped=true&"
import script from "./TSZ_Recordar_Contraseña.vue?vue&type=script&lang=js&"
export * from "./TSZ_Recordar_Contraseña.vue?vue&type=script&lang=js&"
import style0 from "./TSZ_Recordar_Contraseña.vue?vue&type=style&index=0&id=036666b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036666b3",
  null
  
)

export default component.exports